import type { TColumnsMargin, TColumnsWidth } from '../models';

type TUnion = string | number;

const isNumber = (value: TUnion): value is number => typeof value === 'number';

const toArray = (value: TColumnsWidth | TColumnsWidth[] | TColumnsMargin) =>
    (Array.isArray(value) ? value : [value]) as Array<TUnion | null>;

const getItemByIndexOrLast = (idx: number, array: TColumnsWidth[] | TColumnsMargin[]) =>
    array.length - 1 < idx ? array[array.length - 1] : array[idx];

const mapWidth = (value: TUnion) => {
    if (isNumber(value) && value > 0 && value <= 1) {
        return `${value * 100}%`;
    }

    if (isNumber(value) && value > 1) {
        return `${value}px`;
    }

    return value;
};

const mapShrink = (width: TUnion) => (width ? 0 : null);

const mapMargin = (value: TUnion) => value + 'px';

const getColumnStyle = (
    style: string,
    mapValue: typeof mapWidth | typeof mapShrink | typeof mapMargin
) => {
    return (idx: number, values: TColumnsWidth | TColumnsWidth[] | TColumnsMargin) => {
        const arrayStyles = toArray(values);
        const styleValue = getItemByIndexOrLast(idx, arrayStyles);

        return styleValue ? { [style]: mapValue(styleValue as TUnion) } : null;
    };
};

export { mapWidth, mapShrink, mapMargin, getColumnStyle };
